import { Navbar } from "@/components/layout";

interface HeaderProps {
  onMobileMenuToggle?: () => void;
  showMobileMenuButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onMobileMenuToggle, showMobileMenuButton }) => {
  return <Navbar 
    onMobileMenuToggle={onMobileMenuToggle || undefined} 
    showMobileMenuButton={showMobileMenuButton || false} 
  />;
};

export default Header;
